import React from 'react';
import anchorme from 'anchorme';
import { ReactComponent as PlansIcon } from './icons/plans.svg';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
import styled from 'styled-components';
import { IPlansBlockPreviewProps } from './IPlansBlockPreviewProps';
import PlansBlockPlanPreview from './PlansBlockPlanPreview';

const PlansBlockContainer: any = styled.div`
  width: 100%;
  margin-top: 25px;
`;

const PlansBlockEmptyContainer: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #FFFFFF;
  padding: 80px 0;
`;

const PlansBlockEmptyIconContainer: any = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlansBlockEmptyTitle: any = styled.h1`
  margin: 0;
  padding: 0;
  text-align: center;
  margin-top: 20px;
  font-weight: 500;
  font-size: 24px;
  line-height: 29.05px;
 color: #191b1f;
`;

const PlansBlockEmptySubtext: any = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
  margin-top: 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19.36px;
  color: #666666;
`;

const PlansBlockPlansContainer: any = styled.div<{design: any}>`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: ${(props: any) =>
      props.design.content_container_alignment === 'center' ?
      'center' :
      props.design.content_container_alignment === 'right' ?
      'flex-end' :
      'flex-start'
    };

    &.mobile {
        padding-left: 5px;
        padding-right: 5px;
    }

    @media(max-width: 768px) {
        padding-left: 5px;
        padding-right: 5px;
    }
`;

const PlansBlockPreview: React.FC<IPlansBlockPreviewProps> = (props) => {

  const getElements = () => {
    if(
      !props.blockData.plans.length
    ) {
      return (
        <PlansBlockEmptyContainer
        >
          <PlansBlockEmptyIconContainer
          >
            <PlansIcon
            />
          </PlansBlockEmptyIconContainer>

          <PlansBlockEmptyTitle
          >
            Add plans or pricing options
          </PlansBlockEmptyTitle>

          <PlansBlockEmptySubtext
          >
            Choose plans or pricing options on the left side menu to display them here.
          </PlansBlockEmptySubtext>
        </PlansBlockEmptyContainer>
      )
    }

    return (
      <PlansBlockPlansContainer
      className={`${props.view ? props.view : ''}`}
      design={props.blockData.design}
      >
        {props.blockData.plans.map((plan: any, index: number) => (
          <PlansBlockPlanPreview
          buildingPreview={props.buildingPreview}
          key={`${plan.id}`}
          plan={plan}
          index={index}
          blockData={props.blockData}
          view={props.view}
          pageStyles={props.pageStyles}
          group={props.group}
          containerBaseIdName={props.containerBaseIdName}
          pageFormsOpenState={props.pageFormsOpenState}
          setPageFormsOpenState={props.setPageFormsOpenState}
          />
        ))}
      </PlansBlockPlansContainer>
    )

  }

  return (
    <BlockContainer
    design={props.blockData.design}
    >
        <BlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
          <BlockTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="heading"
          fallbackTextColor="#000000"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.heading),
          }}
          />

          <BlockSubTextContainer
          design={props.blockData.design}
          pageStyles={props.pageStyles}
          textKey="subtext"
          fallbackTextColor="#666666"
          dangerouslySetInnerHTML={{
              __html: anchorme(props.blockData.subtext),
          }}
          />

          <PlansBlockContainer
          design={props.blockData.design}
          >
            {getElements()}
          </PlansBlockContainer>
        </BlockContentContainer>
    </BlockContainer>
  )
}

export default PlansBlockPreview;